
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/[category]",
      function () {
        return require("private-next-pages/collections/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections/[category]"])
      });
    }
  